import React, { useEffect, useContext } from 'react';
import { useParams} from "react-router";

import {
    LinearProgress,
    Container
} from '@material-ui/core';

import { RolesProvider, RolesContext } from './RolesContext';
import { NavContext } from '../../../contexts';

import {    
    RoleHeader,
    UserList    
} from './components';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    root: {
    }
});

const PageContent = () => {    
    const { addBreadcrumbToken } = useContext(NavContext);    
    
    const { 
        state,
        isLoadingRole,
        getRoleAsync,        
    } = useContext(RolesContext);

    const {
        role
    } = state;
    
    const { roleId } = useParams();
    useEffect(() => {        
        getRoleAsync(roleId);
    }, [roleId])

    useEffect(() => {                
        if(role) {
            addBreadcrumbToken(state.role.groupName);
        }
    }, [role]);

    return (
        <>
            {isLoadingRole &&
                <LinearProgress color="primary" />
            }           
            {role &&
                <Container maxWidth="lg">            
                    <RoleHeader />
                    <UserList />
                </Container>
            }
        </>
    );
}

export const RolePage = () => {
    return (
        <RolesProvider>
            <PageContent />
        </RolesProvider>
    );
}